import K_HR from "../templates/K_HR";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface HROptions extends ComponentOptions {
    vertical?: "vertical-seperator";
    bsc?: string;
    style?: string;
}

export class HR extends TemplateComponent {

    options: HROptions;

    constructor(options?: HROptions) {
        super(K_HR, options || {});
    }

}
